import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import AdminView from "../views/AdminView.vue";
import IntroductionView from "../views/IntroductionView.vue";
import EnvironmentView from "../views/EnvironmentView.vue";
import EnvironmentCommunityView from "../views/EnvironmentCommunityView.vue";
import RequirementDocumentsView from "../views/RequirementDocumentsView.vue"
import RequirementView from "../views/RequirementView.vue";
import GuideView from "../views/GuideView.vue";
import MapView from "../views/MapView.vue";
import NoticeView from "../views/NoticeView.vue";
import ApplyView from "../views/ApplyView.vue";
import ApplyFinanceView from "@/views/ApplyFinanceView.vue";
import NoticeDetailView from "@/views/NoticeDetailView.vue";
import NoticeCreateView from "@/views/NoticeCreateView.vue";
import ResourcesView from "@/views/ResourcesView.vue";
import ResourceDetailView from "@/views/ResourceDetailView.vue";
import ResourceCreateView from "@/views/ResourceCreateView.vue";
import ApplyCreateView from "@/views/ApplyCreateView.vue";
import SubscriptionApplicantsDetailView from "@/views/SubscriptionApplicantsDetailView.vue";
import AdminPopup from "@/views/AdminPopup.vue";
import AdminCreatePopup from "@/views/AdminCreatePopup.vue";
import PopupPage from "@/components/BasePopup.vue"
import InquiryPage from "@/views/InquiryPage.vue";
import { jwtDecode } from 'jwt-decode'; // ✅ named import 사용


const routes = [
  { path: "/", name: "Home", component: HomeView },
  { path: "/login", name: "Login", component: LoginView },

  // ✅ 관리자 영역
  {
    path: "/admin",
    meta: { isAdmin: true },
    children: [
      {
        path: "", // /admin
        name: "AdminHome",
        component: AdminView
      },
      {
        path: "apply/create",
        name: "ApplyCreate",
        component: ApplyCreateView,
        props: { mode: "create" }
      },
      {
        path: "apply/edit/:id",
        name: "ApplyEdit",
        component: ApplyCreateView,
        props: route => ({ mode: "edit", id: route.params.id })
      },
      {
        path: "subscriptionApplicants/detail",
        name: "SubscriptionDetail",
        component: SubscriptionApplicantsDetailView
      },
      {
        path: "notice/new",
        name: "NoticeCreate",
        component: NoticeCreateView,
        props: { mode: "create" }
      },
      {
        path: "notice/edit/:id",
        name: "NoticeEdit",
        component: NoticeCreateView,
        props: route => ({ mode: "edit", id: route.params.id })
      },
      {
        path: "resource/new",
        name: "ResourceCreate",
        component: ResourceCreateView,
        props: { mode: "create" }
      },
      {
        path: "resource/edit/:id",
        name: "ResourceEdit",
        component: ResourceCreateView,
        props: route => ({
          mode: "edit",
          id: route.params.id
        })
      },
      {
        path: "popup",
        name: "AdminPopup",
        component: AdminPopup,
      },
      {
        path: "popup/create",
        name: "AdminCreatePopup",
        component: AdminCreatePopup,
      },
      // 라우트 설정 (props 제거)
      {
        path: "popup/edit/:id",
        name: "PopupEdit",
        component: AdminCreatePopup,
      }
    ]
  },

  // ✅ 일반 사용자 영역
  { path: "/introduction", component: IntroductionView, name: "Introduction" },
  { path: "/environment", component: EnvironmentView, name: "Environment" },
  { path: "/environment/community", component: EnvironmentCommunityView, name: "EnvironmentCommunity" },
  { path: "/requirement", component: RequirementView, name: "Requirement" },
  { path: "/requirement/documents", component: RequirementDocumentsView, name: "RequirementDocuments" },
  { path: "/guide", component: GuideView, name: "Guide" },
  { path: "/map", component: MapView, name: "Map" },
  { path: "/notice", component: NoticeView, name: "Notice" },
  { path: "/notice/resources", component: ResourcesView, name: "Resources" },
  { path: "/apply", component: ApplyView, name: "Apply" },
  { path: "/apply/finance", component: ApplyFinanceView, name: "ApplyFinance" },
  { path: "/inquiry", component: InquiryPage, name: "Inquiry" },
  {
    path: '/apply/edit/:id',
    name: 'ApplicationEdit',
    component: () => import('@/views/ApplyEditView.vue'),
    props: true
  },
  // ✅ 상세 보기
  {
    path: "/notice/detail/:id",
    name: "NoticeDetail",
    component: NoticeDetailView,
    props: true
  },
  {
    path: "/resources/detail/:id",
    name: "ResourceDetail",
    component: ResourceDetailView,
    props: true
  },

  // ✅ 팝업 창
  {
    path: "/popup/:id", // 팝업을 id에 따라 동적으로 로드
    name: "PopupPage",
    component: PopupPage,
    props: true
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const clearAdminToken = () => {
  localStorage.removeItem('adminToken');
};

// 라우터 후크 추가
router.afterEach(() => {
  // 라우트 이동 후 항상 화면을 최상단으로 스크롤
  window.scrollTo(0, 0);
});


router.beforeEach((to, from, next) => {
  if (to.meta.isAdmin) {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      alert('로그인이 필요합니다.');
      return next('/login');
    }

    try {
      const decoded = jwtDecode(token);

      if (decoded.exp * 1000 < Date.now()) {
        clearAdminToken();
        alert('토큰이 만료되었습니다.');
        return next('/login');
      }
      
      if (decoded.roles !== 'ROLE_ADMIN') {
        clearAdminToken();
        alert('관리자 권한이 없습니다.');
        return next('/login');
      }
    } catch (e) {
      clearAdminToken();
      alert('토큰이 유효하지 않습니다.');
      return next('/login');
    }
  }

  next();
});


export default router;
